import React, { useState } from "react";
import { MdHourglassTop, MdAvTimer, MdOutlineTextsms } from "react-icons/md";
import FlashType from "@ltypes/flash";
import Button from "@components/forms/Button/Button";
import SceneType from "@enums/sceneType";
import { ScenePomodoro, SceneText, TextLine, SceneTimer } from "@ltypes/scene";
import { useTranslation } from "react-i18next";
import './Flash.scss';

type FlashProps = {
    className?: string,
    flash: FlashType,
    onStop: () => void,
};

function Flash(props: FlashProps) {

    const [canStop, setCanStop] = useState<boolean>(true);

    const { t } = useTranslation();

    const handleStop = () => {
        setCanStop(false);
        props.onStop();
    };

    const getContent = (): React.ReactNode => {
        // const expiredAt = new Date(props.flash.expire_at);
        // const now = new Date();
        // const utc = new Date(
        //     now.getUTCFullYear(),
        //     now.getUTCMonth(),
        //     now.getUTCDate(),
        //     now.getUTCHours(),
        //     now.getUTCMinutes(),
        //     now.getUTCSeconds()
        // );

        if(props.flash.scene.type === SceneType.TIMER) {
            const sceneTimer: SceneTimer = props.flash.scene as SceneTimer;
            return (
                <>
                    {t('page.scenes.type.timer')} {sceneTimer.timer}
                </>
            );
        }
        else if(props.flash.scene.type === SceneType.POMODORO) {
            const sceneTimer: ScenePomodoro = props.flash.scene as ScenePomodoro;
            return (
                <>
                    {t('page.scenes.type.pomodoro')} {sceneTimer.work_time} / {sceneTimer.break_time}
                </>
            );
        }
        else if(props.flash.scene.type === SceneType.TEXT) {
            const sceneText: SceneText = props.flash.scene as SceneText;
            return (
                <>
                    {t('page.scenes.type.text')} "{sceneText.lines.map((line: TextLine) => line.text).join(' ')}"
                </>
            );
        }

        return <>Flash in progress</>;
    };

    // return (
    //     <div className="flash-container">
    //         <div className="flash-time">
    //             <FaHourglassHalf/> 14:54
    //         </div>
    //         <div className="flash-type">
    //             {props.flash.scene.type}
    //         </div>
    //         <div className="flash-content">
    //             "Happy new year"
    //         </div>
    //         <span className="flash-close" onClick={handleDelete}><FaRegTrashCan size="1.2rem"/></span>
    //     </div>
    // );

    return (
        <div className="flash-container">
            <div className="flash-icon">
                {props.flash.scene.type === SceneType.TIMER ? <MdHourglassTop size="1.5rem"/>
                : props.flash.scene.type === SceneType.POMODORO ? <MdAvTimer size="1.5rem"/>
                : props.flash.scene.type === SceneType.TEXT ? <MdOutlineTextsms size="1.5rem"/>
                : <></>}
            </div>
            <div className="flash-content">
                {getContent()}
            </div>
            <div className="flash-stop">
                <Button className="red" size="sm" disabled={!canStop} onClick={handleStop}>Stop</Button>
            </div>
        </div>
    );
}

export default Flash;
